import axios, { AxiosInstance, AxiosResponse, Method } from "axios";
import { config } from "../configs/axios";

const axiosInstance: AxiosInstance = axios.create(config);

export const request = <T>(method: Method, url: string, payload = {}): Promise<AxiosResponse<T>> => {
  return axiosInstance.request<T>({ method, url, data: payload });
};

export default axiosInstance;